/**
 * Oyster `/users/me`-shaped object (subset).
 * @param {object|null|undefined} user
 * @returns {boolean}
 */
export function isOraclePowerUser(user) {
    if (!user) return false;
    return Boolean(user.isItTeam || user.isTeamLead || user.isItLeadership);
}

/**
 * Executive Pulse access without IT responsibilities → minimal Oracle shell + dashboard-only UX.
 * @param {object|null|undefined} user
 * @returns {boolean}
 */
export function isExecOnlyOracleViewer(user) {
    if (!user) return false;
    return Boolean(user.executivePulseAccess) && !isOraclePowerUser(user);
}
